// extracted by mini-css-extract-plugin
module.exports = {"fancy":"fancy-line-module--fancy--of7MF"};